import { useEffect } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { useTheme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function LightboxModal({
  images,
  photoIndex,
  setPhotoIndex,
  isOpen,
  onClose,
  onCloseRequest, // Support old API
  ...other
}: any) {
  const theme = useTheme();

  // Support both onClose and onCloseRequest for backward compatibility
  const handleClose = onClose || onCloseRequest || (() => {});

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isOpen]);

  // Convert images array to lightbox format
  const slides = images.map((src: string) => ({ src }));

  return (
    <Lightbox
      open={isOpen}
      close={handleClose}
      slides={slides}
      index={photoIndex}
      on={{
        view: ({ index }: { index: number }) => setPhotoIndex(index),
      }}
      styles={{
        container: {
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(0, 0, 0, 0.96)"
              : "rgba(0, 0, 0, 0.9)",
        },
      }}
      {...other}
    />
  );
}
